(function (root, documentRef) {
  'use strict';

  if (!root || !documentRef || root.MarineMaxLocationDetailPage) return;

  var LOCATION_DETAIL_TEAM_MOBILE_THRESHOLD = 10;
  var TESTIMONIAL_ID_PREFIX = 'location-detail-testimonial-';
  var locationDetailTeamMoreResizeBound = false;

  function collectWithin(scope, selector) {
    var searchRoot = scope && typeof scope.querySelectorAll === 'function' ? scope : documentRef;
    var elements = [];
    if (typeof searchRoot.matches === 'function' && searchRoot.matches(selector)) {
      elements.push(searchRoot);
    }
    searchRoot.querySelectorAll(selector).forEach(function (element) {
      if (elements.indexOf(element) === -1) elements.push(element);
    });
    return elements;
  }

  function initLocationDetailTestimonial(sectionId) {
    var container = documentRef.getElementById(TESTIMONIAL_ID_PREFIX + sectionId);
    if (!container) return;

    var swiperEl = container.querySelector('.location-detail__testimonial-slider');
    var paginationEl = container.querySelector('.location-detail__testimonial-pagination');
    if (!swiperEl || !root.FoxTheme || typeof root.FoxTheme.Carousel !== 'function') return;

    var slides = swiperEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }

    var carouselOptions = {
      slidesPerView: 1,
      loop: true,
      pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
      threshold: 5,
      speed: 500,
    };
    var autoplayEnabled = container.getAttribute('data-testimonial-autoplay') === 'true';
    var autoplayDelay = parseInt(container.getAttribute('data-testimonial-autoplay-delay'), 10);
    var modules = null;
    if (autoplayEnabled && !isNaN(autoplayDelay) && autoplayDelay > 0) {
      carouselOptions.autoplay = {
        delay: autoplayDelay * 1000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
      if (root.FoxTheme.Swiper && root.FoxTheme.Swiper.Autoplay) {
        modules = [root.FoxTheme.Swiper.Autoplay];
      }
    }
    var sliderInstance = new root.FoxTheme.Carousel(swiperEl, carouselOptions, modules);
    sliderInstance.init();
  }

  function initLocationDetailTestimonials(scope) {
    collectWithin(
      scope,
      '.location-detail__testimonial[id^="' + TESTIMONIAL_ID_PREFIX + '"]',
    ).forEach(function (container) {
      initLocationDetailTestimonial(container.id.slice(TESTIMONIAL_ID_PREFIX.length));
    });
  }

  function initLocationDetailTeamMore(scope) {
    collectWithin(scope, '[data-location-team]').forEach(function (teamSection) {
      var grid = teamSection.querySelector('[data-location-team-grid]');
      if (!grid) return;
      var cards = grid.querySelectorAll(':scope > .location-detail__team-card');
      var moreBtn = teamSection.querySelector('[data-location-team-more]');
      var labelMore = 'More';
      var labelLess = 'Less';
      var moreAriaLabel = 'Show more team members';
      var lessAriaLabel = 'Show fewer team members';

      cards.forEach(function (card, i) {
        card.classList.toggle('location-detail__team-card--mobile-extra', i >= LOCATION_DETAIL_TEAM_MOBILE_THRESHOLD);
      });

      if (cards.length <= LOCATION_DETAIL_TEAM_MOBILE_THRESHOLD) {
        teamSection.classList.remove('location-detail__team--expanded');
        if (moreBtn) {
          moreBtn.remove();
        }
        return;
      }

      if (!moreBtn) {
        moreBtn = documentRef.createElement('button');
        moreBtn.type = 'button';
        moreBtn.className = 'btn btn--secondary location-detail__team-more';
        moreBtn.setAttribute('data-location-team-more', '');
        moreBtn.setAttribute('aria-expanded', 'false');
        var gridId = grid.getAttribute('id');
        if (gridId) {
          moreBtn.setAttribute('aria-controls', gridId);
        }
        moreBtn.setAttribute('aria-label', moreAriaLabel);
        moreBtn.innerHTML = '<span class="btn__text">' + labelMore + '</span>';
        teamSection.appendChild(moreBtn);
        moreBtn.addEventListener('click', function () {
          var expanded = teamSection.classList.toggle('location-detail__team--expanded');
          moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          moreBtn.setAttribute('aria-label', expanded ? lessAriaLabel : moreAriaLabel);
          var t = moreBtn.querySelector('.btn__text');
          if (t) t.textContent = expanded ? labelLess : labelMore;
        });
      } else {
        teamSection.classList.remove('location-detail__team--expanded');
        moreBtn.setAttribute('aria-expanded', 'false');
        moreBtn.setAttribute('aria-label', moreAriaLabel);
        var tReset = moreBtn.querySelector('.btn__text');
        if (tReset) tReset.textContent = labelMore;
      }
    });

    if (!locationDetailTeamMoreResizeBound) {
      locationDetailTeamMoreResizeBound = true;
      var desktopMedia = typeof root.matchMedia === 'function'
        ? root.matchMedia('(min-width: 990px)')
        : null;
      var handleDesktopMatch = function (event) {
        if (!event.matches) return;
        documentRef
          .querySelectorAll('[data-location-team].location-detail__team--expanded')
          .forEach(function (element) {
            element.classList.remove('location-detail__team--expanded');
            var button = element.querySelector('[data-location-team-more]');
            if (button) {
              button.setAttribute('aria-expanded', 'false');
              button.setAttribute('aria-label', 'Show more team members');
              var text = button.querySelector('.btn__text');
              if (text) text.textContent = 'More';
            }
          });
      };
      if (desktopMedia && typeof desktopMedia.addEventListener === 'function') {
        desktopMedia.addEventListener('change', handleDesktopMatch);
      } else if (desktopMedia && typeof desktopMedia.addListener === 'function') {
        desktopMedia.addListener(handleDesktopMatch);
      }
    }
  }

  function initLocationDetailHoursForSection(sectionId) {
    var openTrigger = documentRef.querySelector('[data-location-hours-open="' + sectionId + '"]');
    var modal = documentRef.querySelector('[data-location-hours-modal="' + sectionId + '"]');
    if (!openTrigger || !modal || modal.dataset.hoursWired === '1') return;
    modal.dataset.hoursWired = '1';

    var closeBtn = modal.querySelector('[data-location-hours-close]');

    function openModal() {
      modal.classList.add('location-detail-hours-modal--open');
      documentRef.documentElement.classList.add('location-detail-hours-modal-open');
    }

    function closeModal() {
      modal.classList.remove('location-detail-hours-modal--open');
      documentRef.documentElement.classList.remove('location-detail-hours-modal-open');
    }

    openTrigger.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    }

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.classList.contains('location-detail-hours-modal__backdrop')) {
        closeModal();
      }
    });

    documentRef.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('location-detail-hours-modal--open')) {
        closeModal();
      }
    });

    var tabsContainer = modal.querySelector('[data-hours-tabs="' + sectionId + '"]');
    if (tabsContainer) {
      var tabs = tabsContainer.querySelectorAll('.location-detail-hours-modal__tab');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var panelId = tab.getAttribute('data-hours-panel');
          var dialog = modal.querySelector('.location-detail-hours-modal__dialog');
          if (!dialog) return;
          var allTabs = dialog.querySelectorAll('.location-detail-hours-modal__tab');
          var allPanels = dialog.querySelectorAll('.location-detail-hours-modal__panel');
          allTabs.forEach(function (t) {
            t.classList.remove('location-detail-hours-modal__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          allPanels.forEach(function (p) {
            p.classList.remove('location-detail-hours-modal__panel--active');
          });
          tab.classList.add('location-detail-hours-modal__tab--active');
          tab.setAttribute('aria-selected', 'true');
          var panel = dialog.querySelector('[data-hours-panel-id="' + panelId + '"]');
          if (panel) panel.classList.add('location-detail-hours-modal__panel--active');
        });
      });
    }
  }

  function initLocationDetailHoursModals(scope) {
    collectWithin(scope, '[data-location-hours-open]').forEach(function (trigger) {
      var sectionId = trigger.getAttribute('data-location-hours-open');
      if (sectionId) initLocationDetailHoursForSection(sectionId);
    });
  }

  function runLocationDetailPageInit(scope) {
    var searchRoot = scope && typeof scope.querySelectorAll === 'function' ? scope : documentRef;
    initLocationDetailHoursModals(searchRoot);
    initLocationDetailTeamMore(searchRoot);
    initLocationDetailTestimonials(searchRoot);
  }

  var api = Object.freeze({
    initialize: runLocationDetailPageInit,
    initHours: initLocationDetailHoursModals,
    initTeam: initLocationDetailTeamMore,
    initTestimonial: initLocationDetailTestimonial,
  });
  root.MarineMaxLocationDetailPage = api;
  root.initLocationDetailTestimonial = initLocationDetailTestimonial;
  root.initLocationDetailTeamMore = initLocationDetailTeamMore;

  if (documentRef.readyState === 'loading') {
    documentRef.addEventListener('DOMContentLoaded', function () {
      runLocationDetailPageInit(documentRef);
    }, { once: true });
  } else {
    runLocationDetailPageInit(documentRef);
  }
  documentRef.addEventListener('turbo:load', function () {
    runLocationDetailPageInit(documentRef);
  });
  documentRef.addEventListener('shopify:section:load', function (event) {
    runLocationDetailPageInit(event.target || documentRef);
  });
  root.addEventListener('pageshow', function (event) {
    if (event.persisted) runLocationDetailPageInit(documentRef);
  });
})(window, document);
